import Layout from "./Layout.jsx";
import ScrollToTop from "@/components/ScrollToTop";

import Discover from "./Discover";

import Feedback from "./Feedback";

import Upload from "./Upload";

import Home from "./Home";

import Settings from "./Settings";

import Profile from "./Profile";

import Leaderboard from "./Leaderboard";
import AnnualLeaderboard from "./AnnualLeaderboard";

import Archive from "./Archive";

import Inbox from "./Inbox";

import Notifications from "./Notifications";

import MyTracks from "./MyTracks";

import MyReviews from "./MyReviews";

import Vote from "./Vote";

import ReceivedFeedback from "./ReceivedFeedback";

import BuyCredits from "./BuyCredits";

import AIAnalyzer from "./AIAnalyzer";

import TrackDetails from "./TrackDetails";

import PublicProfile from "./PublicProfile";

import Analytics from "./Analytics";

import SpotifyPlaylists from "./SpotifyPlaylists";

import DevDashboard from "./DevDashboard";

import Moderation from "./Moderation";

import HowItWorks from "./HowItWorks";

import ForArtists from "./ForArtists";

import ForCurators from "./ForCurators";

import SubmithubAlternative from "./SubmithubAlternative";

import PlaylistPushAlternative from "./PlaylistPushAlternative";

import CheapestPlaylistPitching from "./CheapestPlaylistPitching";

import SoundopeVs from "./SoundopeVs";

import FAQ from "./FAQ";

import CookiePolicy from "./CookiePolicy";

import PolicyAcceptance from "./PolicyAcceptance";

import EULA from "./EULA";

import EULAAcceptance from "./EULAAcceptance";

import TOS from "./TOS";

import TOSAcceptance from "./TOSAcceptance";

import PrivacyPolicy from "./PrivacyPolicy";

import PrivacyPolicyAcceptance from "./PrivacyPolicyAcceptance";

import Report from "./Report";

import Disclaimer from "./Disclaimer";

import AcceptableUsePolicy from "./AcceptableUsePolicy";

import CookiesRequired from "./CookiesRequired";

import ReviewerLeaderboard from "./ReviewerLeaderboard";

import ViewFeedback from "./ViewFeedback";

import FreshDopeSounds from "./FreshDopeSounds";

import Auth from "./Auth";

import ForcePasswordChange from "./ForcePasswordChange";

import ResetPassword from "./ResetPassword";

import ForgotPassword from "./ForgotPassword";

import BulkUserImport from "./BulkUserImport";

import Shop from "./Shop";

import GrowthProgram from "./GrowthProgram";

import Submit from "./Submit";

import SubmitOptions from "./SubmitOptions";

import SubmitSuccess from "./SubmitSuccess";

import PremiumPitch from "./PremiumPitch";

import PurchaseHistory from "./PurchaseHistory";

import Cashout from "./Cashout";

import CuratorSubmit from "./CuratorSubmit";

import Tools from "./Tools";
import DeadWords from "./DeadWords";
import WhatWeOffer from "./WhatWeOffer";

import NotFound from "./NotFound";

import Blog from "./Blog";

import BlogPost from "./BlogPost";

import DeleteAccount from "./DeleteAccount";

import Support from "./Support";

import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { RESET_PASSWORD_ROUTE, FORGOT_PASSWORD_ROUTE } from "../constants/routes";

const PAGES = {
    
    Discover: Discover,
    
    Feedback: Feedback,
    
    Upload: Upload,
    
    Home: Home,
    
    Settings: Settings,
    
    Profile: Profile,
    
    Leaderboard: Leaderboard,
    
    AnnualLeaderboard: AnnualLeaderboard,
    
    Archive: Archive,
    
    Inbox: Inbox,
    
    Notifications: Notifications,
    
    MyTracks: MyTracks,
    
    MyReviews: MyReviews,
    
    Vote: Vote,
    
    ReceivedFeedback: ReceivedFeedback,
    
    BuyCredits: BuyCredits,
    
    AIAnalyzer: AIAnalyzer,
    
    TrackDetails: TrackDetails,
    
    PublicProfile: PublicProfile,
    
    Analytics: Analytics,
    
    SpotifyPlaylists: SpotifyPlaylists,
    
    DevDashboard: DevDashboard,
    
    Moderation: Moderation,
    
    HowItWorks: HowItWorks,
    
    ForArtists: ForArtists,
    
    ForCurators: ForCurators,
    
    FAQ: FAQ,
    
    CookiePolicy: CookiePolicy,
    
    PolicyAcceptance: PolicyAcceptance,
    
    EULA: EULA,
    
    EULAAcceptance: EULAAcceptance,
    
    TOS: TOS,
    
    TOSAcceptance: TOSAcceptance,
    
    PrivacyPolicy: PrivacyPolicy,
    
    PrivacyPolicyAcceptance: PrivacyPolicyAcceptance,
    
    Report: Report,
    
    Disclaimer: Disclaimer,
    
    AcceptableUsePolicy: AcceptableUsePolicy,
    
    CookiesRequired: CookiesRequired,
    
    ReviewerLeaderboard: ReviewerLeaderboard,
    
    ViewFeedback: ViewFeedback,
    
    FreshDopeSounds: FreshDopeSounds,
    
    Auth: Auth,
    
    ForcePasswordChange: ForcePasswordChange,
    
    ResetPassword: ResetPassword,
    
    ForgotPassword: ForgotPassword,
    
    BulkUserImport: BulkUserImport,
    Submit: Submit,
    SubmitOptions: SubmitOptions,
    PremiumPitch: PremiumPitch,
    
    PurchaseHistory: PurchaseHistory,
    Shop: Shop,
    GrowthProgram: GrowthProgram,
    Cashout: Cashout,
    CuratorSubmit: CuratorSubmit,
    Tools: Tools,
    DeadWords: DeadWords,
    WhatWeOffer: WhatWeOffer,
    Blog: Blog,
    BlogPost: BlogPost,
    DeleteAccount: DeleteAccount,
    Support: Support,
}

function _getCurrentPage(url) {
    if (url.endsWith('/')) {
        url = url.slice(0, -1);
    }
    let urlLastPart = url.split('/').pop();
    if (urlLastPart.includes('?')) {
        urlLastPart = urlLastPart.split('?')[0];
    }

    const pageName = Object.keys(PAGES).find(page => page.toLowerCase() === urlLastPart.toLowerCase());
    return pageName || Object.keys(PAGES)[0];
}

// Create a wrapper component that uses useLocation inside the Router context
function PagesContent() {
    const location = useLocation();
    const currentPage = _getCurrentPage(location.pathname);
    
    return (
        <Layout currentPageName={currentPage}>
            <Routes>            
                <Route path="/" element={<Home />} />
                <Route path="/Discover" element={<Discover />} />
                
                <Route path="/Feedback" element={<Discover />} />
                
                <Route path="/Upload" element={<Upload />} />
                
                <Route path="/Home" element={<Home />} />
                
                <Route path="/Settings" element={<Settings />} />
                
                <Route path="/Profile" element={<Profile />} />
                
                <Route path="/Leaderboard" element={<Leaderboard />} />
                
                <Route path="/AnnualLeaderboard" element={<AnnualLeaderboard />} />
                
                <Route path="/Archive" element={<Archive />} />
                
                <Route path="/Inbox" element={<Inbox />} />
                
                <Route path="/Notifications" element={<Notifications />} />
                
                <Route path="/MyTracks" element={<MyTracks />} />
                
                <Route path="/MyReviews" element={<MyReviews />} />
                
                <Route path="/Vote" element={<Vote />} />
                
                <Route path="/ReceivedFeedback" element={<ReceivedFeedback />} />
                
                <Route path="/BuyCredits" element={<BuyCredits />} />
                
                <Route path="/AIAnalyzer" element={<AIAnalyzer />} />
                
                <Route path="/TrackDetails" element={<TrackDetails />} />
                
                <Route path="/PublicProfile" element={<PublicProfile />} />
                
                <Route path="/Analytics" element={<Analytics />} />
                
                <Route path="/SpotifyPlaylists" element={<SpotifyPlaylists />} />
                
                <Route path="/DevDashboard" element={<DevDashboard />} />
                
                <Route path="/Moderation" element={<Moderation />} />
                
                <Route path="/HowItWorks" element={<HowItWorks />} />
                
                <Route path="/ForArtists" element={<ForArtists />} />
                
                <Route path="/ForCurators" element={<ForCurators />} />
                
                <Route path="/submithub-alternative" element={<SubmithubAlternative />} />
                
                <Route path="/playlist-push-alternative" element={<PlaylistPushAlternative />} />
                
                <Route path="/cheapest-playlist-pitching" element={<CheapestPlaylistPitching />} />
                
                <Route path="/vs" element={<SoundopeVs />} />
                
                <Route path="/FAQ" element={<FAQ />} />
                
                <Route path="/CookiePolicy" element={<CookiePolicy />} />
                
                <Route path="/PolicyAcceptance" element={<PolicyAcceptance />} />
                
                <Route path="/EULA" element={<EULA />} />
                
                <Route path="/EULAAcceptance" element={<EULAAcceptance />} />
                
                <Route path="/TOS" element={<TOS />} />
                
                <Route path="/TOSAcceptance" element={<TOSAcceptance />} />
                
                <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
                
                <Route path="/PrivacyPolicyAcceptance" element={<PrivacyPolicyAcceptance />} />
                
                <Route path="/Report" element={<Report />} />
                
                <Route path="/Disclaimer" element={<Disclaimer />} />
                
                <Route path="/AcceptableUsePolicy" element={<AcceptableUsePolicy />} />
                
                <Route path="/CookiesRequired" element={<CookiesRequired />} />
                
                <Route path="/ReviewerLeaderboard" element={<ReviewerLeaderboard />} />
                
                <Route path="/ViewFeedback" element={<ViewFeedback />} />
                
                <Route path="/FreshDopeSounds" element={<FreshDopeSounds />} />
                
                <Route path="/Auth" element={<Auth />} />
                <Route path="/auth" element={<Auth />} />
                
                <Route path="/ForcePasswordChange" element={<ForcePasswordChange />} />
                
                <Route path={RESET_PASSWORD_ROUTE} element={<ResetPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                
                <Route path={FORGOT_PASSWORD_ROUTE} element={<ForgotPassword />} />
                
                <Route path="/BulkUserImport" element={<BulkUserImport />} />
                
                <Route path="/Submit" element={<Submit />} />
                <Route path="/SubmitOptions" element={<SubmitOptions />} />
                <Route path="/submit-options" element={<SubmitOptions />} />
                <Route path="/submit-success" element={<SubmitSuccess />} />
                <Route path="/premium-pitch" element={<PremiumPitch />} />
                <Route path="/PremiumPitch" element={<PremiumPitch />} />
                
                <Route path="/PurchaseHistory" element={<PurchaseHistory />} />
                <Route path="/Shop" element={<Shop />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/GrowthProgram" element={<GrowthProgram />} />
                <Route path="/Cashout" element={<Cashout />} />
                <Route path="/cashout" element={<Cashout />} />
                
                <Route path="/CuratorSubmit" element={<CuratorSubmit />} />
                <Route path="/curator-submit" element={<CuratorSubmit />} />
                
                <Route path="/Tools" element={<Tools />} />
                <Route path="/tools" element={<Tools />} />
                
                <Route path="/DeadWords" element={<DeadWords />} />
                <Route path="/dead-words" element={<DeadWords />} />
                
                <Route path="/WhatWeOffer" element={<WhatWeOffer />} />
                <Route path="/what-we-offer" element={<WhatWeOffer />} />
                
                <Route path="/blog" element={<Blog />} />
                <Route path="/Blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                
                <Route path="/delete-account" element={<DeleteAccount />} />
                <Route path="/DeleteAccount" element={<DeleteAccount />} />
                
                <Route path="/Support" element={<Support />} />
                <Route path="/support" element={<Support />} />
                
                {/* 404 catch-all route */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Layout>
    );
}

export default function Pages() {
    return (
        <Router>
            <ScrollToTop />
            <PagesContent />
        </Router>
    );
}
